/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetClientDto } from './GetClientDto';
import {
    GetClientDtoFromJSON,
    GetClientDtoFromJSONTyped,
    GetClientDtoToJSON,
} from './GetClientDto';
import type { GetCompanyDto } from './GetCompanyDto';
import {
    GetCompanyDtoFromJSON,
    GetCompanyDtoFromJSONTyped,
    GetCompanyDtoToJSON,
} from './GetCompanyDto';
import type { GetSurveyDto } from './GetSurveyDto';
import {
    GetSurveyDtoFromJSON,
    GetSurveyDtoFromJSONTyped,
    GetSurveyDtoToJSON,
} from './GetSurveyDto';

/**
 * 
 * @export
 * @interface GetClientSurveyDto
 */
export interface GetClientSurveyDto {
    /**
     * 
     * @type {string}
     * @memberof GetClientSurveyDto
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof GetClientSurveyDto
     */
    systemNumber: number;
    /**
     * 
     * @type {GetClientDto}
     * @memberof GetClientSurveyDto
     */
    client: GetClientDto;
    /**
     * 
     * @type {GetSurveyDto}
     * @memberof GetClientSurveyDto
     */
    survey: GetSurveyDto;
    /**
     * 
     * @type {GetCompanyDto}
     * @memberof GetClientSurveyDto
     */
    company: GetCompanyDto;
    /**
     * 
     * @type {Date}
     * @memberof GetClientSurveyDto
     */
    preparedDate?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof GetClientSurveyDto
     */
    sentDate?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof GetClientSurveyDto
     */
    answeredDate?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetClientSurveyDto
     */
    active: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetClientSurveyDto
     */
    expired: boolean;
    /**
     * 
     * @type {number}
     * @memberof GetClientSurveyDto
     */
    repetition?: number | null;
    /**
     * 
     * @type {string}
     * @memberof GetClientSurveyDto
     */
    emailTo?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetClientSurveyDto
     */
    emailStatus: GetClientSurveyDtoEmailStatusEnum;
    /**
     * 
     * @type {boolean}
     * @memberof GetClientSurveyDto
     */
    warningLight: boolean;
}


/**
 * @export
 */
export const GetClientSurveyDtoEmailStatusEnum = {
    NotSent: 'NotSent',
    Sent: 'Sent',
    Error: 'Error'
} as const;
export type GetClientSurveyDtoEmailStatusEnum = typeof GetClientSurveyDtoEmailStatusEnum[keyof typeof GetClientSurveyDtoEmailStatusEnum];


/**
 * Check if a given object implements the GetClientSurveyDto interface.
 */
export function instanceOfGetClientSurveyDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "systemNumber" in value;
    isInstance = isInstance && "client" in value;
    isInstance = isInstance && "survey" in value;
    isInstance = isInstance && "company" in value;
    isInstance = isInstance && "active" in value;
    isInstance = isInstance && "expired" in value;
    isInstance = isInstance && "emailStatus" in value;
    isInstance = isInstance && "warningLight" in value;

    return isInstance;
}

export function GetClientSurveyDtoFromJSON(json: any): GetClientSurveyDto {
    return GetClientSurveyDtoFromJSONTyped(json, false);
}

export function GetClientSurveyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetClientSurveyDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'systemNumber': json['systemNumber'],
        'client': GetClientDtoFromJSON(json['client']),
        'survey': GetSurveyDtoFromJSON(json['survey']),
        'company': GetCompanyDtoFromJSON(json['company']),
        'preparedDate': !exists(json, 'preparedDate') ? undefined : (json['preparedDate'] === null ? null : new Date(json['preparedDate'])),
        'sentDate': !exists(json, 'sentDate') ? undefined : (json['sentDate'] === null ? null : new Date(json['sentDate'])),
        'answeredDate': !exists(json, 'answeredDate') ? undefined : (json['answeredDate'] === null ? null : new Date(json['answeredDate'])),
        'active': json['active'],
        'expired': json['expired'],
        'repetition': !exists(json, 'repetition') ? undefined : json['repetition'],
        'emailTo': !exists(json, 'emailTo') ? undefined : json['emailTo'],
        'emailStatus': json['emailStatus'],
        'warningLight': json['warningLight'],
    };
}

export function GetClientSurveyDtoToJSON(value?: GetClientSurveyDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'systemNumber': value.systemNumber,
        'client': GetClientDtoToJSON(value.client),
        'survey': GetSurveyDtoToJSON(value.survey),
        'company': GetCompanyDtoToJSON(value.company),
        'preparedDate': value.preparedDate === undefined ? undefined : (value.preparedDate === null ? null : value.preparedDate.toISOString()),
        'sentDate': value.sentDate === undefined ? undefined : (value.sentDate === null ? null : value.sentDate.toISOString()),
        'answeredDate': value.answeredDate === undefined ? undefined : (value.answeredDate === null ? null : value.answeredDate.toISOString()),
        'active': value.active,
        'expired': value.expired,
        'repetition': value.repetition,
        'emailTo': value.emailTo,
        'emailStatus': value.emailStatus,
        'warningLight': value.warningLight,
    };
}

